import { render, staticRenderFns } from "./MessagePreviewDrawer.vue?vue&type=template&id=8a958396"
import script from "./MessagePreviewDrawer.vue?vue&type=script&lang=js"
export * from "./MessagePreviewDrawer.vue?vue&type=script&lang=js"
import style0 from "./MessagePreviewDrawer.vue?vue&type=style&index=0&id=8a958396&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports